<h2 mat-dialog-title>
  {{ 'LIB_ORDERS.COMMON.ORDERS.ORDER_PREVIEW' | translate }}
</h2>

<mat-dialog-content>
  <orders-page
    [loading]="false"
    [error]="false"
    [submitDisabled]="true"
    [order]="order"
    [title]="title"
    [subtitle]="subTitle"
    [orderFormOptions]="orderFormOptions"
    [orderConfig]="orderConfig"
    [retailProvider]="retailProvider$ | async"
    [stripeKey]="stripeKey"
    [partnerName]="partnerName$ | async"
    [isSMBPayableOverride]="shouldCollectPayment"
    [isInPreviewMode]="true"
    [userOptions]="userOptions"
    [fileUploadUrl]="fileUploadUrl"
  >
  </orders-page>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>{{ 'LIB_ORDERS.COMMON.ACTION_LABELS.CLOSE' | translate }}</button>
</mat-dialog-actions>
